<template>
    <div class="field-time">
    <div class="panelheader">
      <div class="title">
        Time
      </div>
    </div>
    <div class="body">
      <el-row>
        <highcharts :options="options"></highcharts>
      </el-row>
    </div>
  </div>
</template>

<script>
import requests from '../../requests'

export default {
  props: {
    displayFields: Array,
    dateRange: Object
  },
  'name':'field-usage',
  data(){
    return {
      from: '',
      btn_filters: {
        day:true,
        week:false,
        month:false
      },
      options: {
        chart: {
          type: 'column',
          height: 280
        },
        credits: {
          enabled: false
        },
        title: {
            text: 'Field Time On'
        },
        xAxis: {
            categories: [],
            title: {
                text: 'Fields'
            },
            min: 0
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Time On (Hours)'
            },
            gridLineWidth: 1,
            minorGridLineWidth: 0
        },
        tooltip: {
          enabled: true,
          formatter: function() {
            var t = this.y * 60;
            var h = parseInt(t / 60)
            var m = parseInt(t % 60)
            var s = parseInt(t * 60 % 60)
            var f = `${h}h ${m}m ${s}s`
            return `<b>${this.series.name}</b>: ${f}`
          }
        },
        series: []
      }
    }
  },
  beforeMount() {
    this.getFieldsTimes()
  },
  methods: {
    getFieldsTimes(){
      const from = new Date(this.dateRange.from)
      const to = new Date(this.dateRange.to)

      requests.getFieldsTime(this, from, to, result => {
        this.options.series = []
        if (result.action === 'success' && result.data) {
          this.options.series = result.data
            .filter(v => this.displayFields.find(u => v.field_id == u))
            .reduce((a, field) => {
              const d = field.duration
              const duration = parseInt(d.split(':')[0]) + parseFloat(d.split(':')[1]/60) + parseFloat(d.split(':')[2]/60/60)
              const fieldName = field.field_name

              const alreadyIn = a.find(v => v.name == fieldName)
              if (alreadyIn) {
                alreadyIn.data[0] += duration
              } else {
                const o = { name: fieldName, data: [duration] }
                a.push(o)
              }
              return a
            }, [])

          // this.options.xAxis.categories = Object.keys(durations)
          // console.log('durations', durations)
        }
      })


    },
  },
  watch: {
    displayFields() {
      this.getFieldsTimes()
    },
    dateRange() {
      this.getFieldsTimes()
    }
  }
  // beforeMount(){
  //   var from = new Date();
  //   var to = new Date();

  //   from.setHours(0);
  //   from.setMinutes(0);
  //   from.setSeconds(0);
  //   to.setHours(0);
  //   to.setMinutes(0);
  //   to.setSeconds(0);

  //   this.getFieldsTimes(from, to);

  // },
  // getFieldsTimes(from, to){
  //     var context = this;
  //     this.from = from;
  //     this.to = to;

  //     this.$emit('updateParams', from);
  //     this.$emit('updateParams', to);

  //     requests.getFieldsTime(this, from, to, function (result) {
  //       context.options.xAxis.categories = [];
  //       context.options.series[0].data = [];

  //       var durationSums = {};

  //       if(result.action === "success") {
  //         for (var i = 0; i < result.data.length; i++) {
  //           var field = result.data[i];

  //           var a = field.duration;
  //           var d = parseInt(a.split(':')[0]) + parseFloat(a.split(':')[1]/60) + parseFloat(a.split(':')[2]/60/60)
  //           if(durationSums.hasOwnProperty(field.field_name)) {
  //             durationSums[field.field_name] += d;
  //           } else {
  //             durationSums[field.field_name] = d;
  //           }
  //         }
  //         context.options.xAxis.categories = Object.keys(durationSums);
  //         context.options.series[0].data = Object.values(durationSums);
  //       }
  //     })
  //   }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// FieldsTime.vue?d1a5af24